import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

const getSampleRate = (value: string | undefined, fallback: number) => {
  if (value === undefined || value.trim() === '') {
    return fallback
  }

  const parsed = Number(value)
  return Number.isNaN(parsed) ? fallback : parsed
}

const commonInitConfiguration = {
  applicationId: process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID ?? '',
  clientToken: process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN ?? '',
  site: 'datadoghq.eu',
  service: process.env.NEXT_PUBLIC_DD_SERVICE,
  env: process.env.NEXT_PUBLIC_DD_ENV,
  version: process.env.NEXT_PUBLIC_DD_VERSION,
  sessionSampleRate: getSampleRate(
    process.env.NEXT_PUBLIC_DD_RUM_SESSION_SAMPLE_RATE,
    10
  ),
  sessionReplaySampleRate: getSampleRate(
    process.env.NEXT_PUBLIC_DD_RUM_SESSION_REPLAY_SAMPLE_RATE,
    0
  ),
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
}

export function initDatadogRum() {
  datadogRum.init({
    ...commonInitConfiguration,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })

  datadogRum.startSessionReplayRecording()
}

export function initDatadogLogs() {
  datadogLogs.init({
    ...commonInitConfiguration,
    forwardErrorsToLogs: false,
    telemetrySampleRate: 0
  })
}
